import React from "react";
import { FormProvider, useForm } from "react-hook-form";
import CommonModal from "../common11/commonModals/CommonModal";
import InputField from "../common11/formInputs/InputField";

const AddFilesDocsModal = ({ isOpen, onClose, patientInfo = {} }) => {
  const name = patientInfo?.name ?? "—";
  const uhid = patientInfo?.uhid ?? "—";
  const age = patientInfo?.age ?? patientInfo?.ageGender ?? "—";
  const gender = patientInfo?.gender ?? "—";

  const methods = useForm({
    defaultValues: {
      fileName: "",
      filePath: "",
    },
  });

  const { reset } = methods;

  const handleAdd = () => {
    // TODO: push row to file list
    reset({ fileName: "", filePath: "" });
  };

  const handleSaveLink = () => {
    // TODO: persist file links
    onClose();
  };

  return (
    <CommonModal
      isOpen={isOpen}
      onClose={onClose}
      title="Add Files / Documents"
      size="lg"
      showCloseButton
      disableBackdropClose={true}
      DialogContent={
        <FormProvider {...methods}>
          <div className="space-y-4">
            {/* Patient info header */}
            <div className="bg-gray-100 rounded-lg p-3 border border-gray-200 shadow-sm flex flex-wrap items-center justify-between gap-x-6 gap-y-3">
              <div className="flex items-center gap-4 flex-1 min-w-0">
                <div className="flex-shrink-0">
                  <div className="w-10 h-10 rounded-full bg-gray-300 flex items-center justify-center overflow-hidden">
                    {name && name !== "—" ? (
                      <span className="text-sm font-semibold text-gray-600">
                        {String(name).charAt(0).toUpperCase()}
                      </span>
                    ) : (
                      <span className="text-sm font-semibold text-gray-600">?</span>
                    )}
                  </div>
                </div>
                <div className="flex flex-1 flex-wrap items-center justify-between gap-x-6 gap-y-1 text-xs sm:text-sm min-w-0">
                  <span className="text-[#217E90] font-semibold truncate">{name}</span>
                  <div className="flex items-baseline gap-2">
                    <span className="text-gray-500 text-[11px] shrink-0">Age</span>
                    <span className="text-[#217E90] font-semibold">: {age}</span>
                  </div>
                  <div className="flex items-baseline gap-2">
                    <span className="text-gray-500 text-[11px] shrink-0">Gender</span>
                    <span className="text-[#217E90] font-semibold">: {gender}</span>
                  </div>
                  <div className="flex items-baseline gap-2">
                    <span className="text-gray-500 text-[11px] shrink-0">UHID</span>
                    <span className="text-[#217E90] font-semibold">: {uhid}</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Files table */}
            <div className="border border-gray-200 rounded-lg overflow-hidden">
              <div className="bg-[#F8FEFF] border-b border-gray-200 px-3 py-2 text-sm font-semibold text-[#217E90]">
                Files / Documents
              </div>
              <div className="overflow-x-auto max-h-[220px] overflow-y-auto bg-gray-50">
                <table className="w-full text-sm border-collapse">
                  <thead className="bg-[#E3EEF9] sticky top-0 z-10">
                    <tr>
                      <th className="border-b border-r px-3 py-2 text-left font-semibold text-gray-700 whitespace-nowrap">
                        File Name
                      </th>
                      <th className="border-b px-3 py-2 text-left font-semibold text-gray-700 whitespace-nowrap">
                        File Location
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td colSpan={2} className="py-8 text-center text-gray-500">
                        No files added
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            {/* File fields */}
            <div className="space-y-3">
              <InputField
                name="fileName"
                control={methods.control}
                label="File Name"
                fontSize="text-xs"
              />
              <div className="grid grid-cols-[auto,1fr] gap-2 items-end">
                <button
                  type="button"
                  className="h-9 w-10 rounded-md bg-[#217E90] text-white text-sm font-semibold flex items-center justify-center"
                >
                  ...
                </button>
                <InputField
                  name="filePath"
                  control={methods.control}
                  label="File Path"
                  fontSize="text-xs"
                />
              </div>
            </div>
          </div>
        </FormProvider>
      }
      actions={[
        {
          onClick: handleAdd,
          label: "Add",
          variant: "primary-filled",
        },
        {
          onClick: handleSaveLink,
          label: "Save Link",
          variant: "primary-filled",
        },
        {
          onClick: onClose,
          label: "Close",
          variant: "outlined",
          type: "button",
        },
      ]}
    />
  );
};

export default AddFilesDocsModal;
